module.exports = __webpack_public_path__ + "img/LouisKnox.1319179e.png";